<template>
  <v-container fluid>
    <PageHeading
      :text="'Тур. операторы/агенства'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-tourist-agency-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать тур. оператора/агенство
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridTouristAgencies ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridTouristAgencies from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageTouristAgencies',
  components: {
    PageHeading,
    GridTouristAgencies
  },
  metaInfo () {
    return {
      title: 'Тур. оператор/агенство'
    }
  },
  mixins: [gridPageInterface]
}
</script>
